const phoneFn = (value) => {
  const ph = value.toString().replace(/\D/g, '')
  return `(${ph.slice(0, 3)}) ${ph.slice(3, 6)}-${ph.slice(6, 10)}`
}

export default {
  phone: phoneFn
}
